// extracted by mini-css-extract-plugin
export default {"container":"xzJtkD","bottomText":"dEFZTy","domainName":"yw3EUb","illustration":"zJxgfn"};